<template>
  <div>
    <v-date-picker
      :value="date"
      locale="fr"
      mode="date"
      is24hr
      :timezone="timezone"
      :masks="masks"
      @input="change($event ? $event : null)"
    >
      <template v-slot="{ inputValue, inputEvents, togglePopover }">
        <input
          readonly
          class="border-0 border-white cursor-pointer outline-none"
          :class="customClasses"
          :value="$moment(date).format(dateFormat)"
          @click="togglePopover"
        />
      </template>
      <template v-slot:footer>
        <hr />
        <div class="mb-2 font-16 text-center">{{ $moment(date).format("HH:mm:ss") }}</div>
        <div class="d-flex align-items-center justify-content-around mb-3 mx-1">
          <v-select
            class="time-picker"
            :clearable="false"
            :value="hour"
            :options="optionHours"
            autowidth
            @input="updateTime($event, 'hour')"
          >
            <template v-slot:open-indicator="{ attributes }">
              <span v-bind="attributes"><font-awesome-icon icon="angle-down" /></span>
            </template>
          </v-select>
          <span>:</span>
          <v-select
            class="time-picker"
            :clearable="false"
            :value="minute"
            :options="optionMinutesSeconds"
            @input="updateTime($event, 'minute')"
          >
            <template v-slot:open-indicator="{ attributes }">
              <span v-bind="attributes"><font-awesome-icon icon="angle-down" /></span>
            </template>
          </v-select>
          <span>:</span>
          <v-select
            class="time-picker"
            :clearable="false"
            :value="second"
            :options="optionMinutesSeconds"
            @input="updateTime($event, 'second')"
          >
            <template v-slot:open-indicator="{ attributes }">
              <span v-bind="attributes"><font-awesome-icon icon="angle-down" /></span>
            </template>
          </v-select>
        </div>
      </template>
    </v-date-picker>
  </div>
</template>

<script>
import VCalendar from "v-calendar/lib/components/calendar.umd";
import VDatePicker from "v-calendar/lib/components/date-picker.umd";

export default {
  components: {
    vCalendar: VCalendar,
    vDatePicker: VDatePicker,
  },
  props: {
    minuteEvent: {
      type: Object,
      default: () => {
        return {};
      },
    },
    dateFormat: {
      type: String,
      default: "YYYY-MM-DD HH:mm",
    },
    customClasses: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      date: null,
      masks: {
        input: [this.dateFormat, "YYYY-MM-DD", "YYYY/MM/DD"],
        inputDateTime: [this.dateFormat, "YYYY-MM-DD HH:mm", "YYYY/MM/DD HH:mm"],
        inputDateTime24hr: [this.dateFormat, "YYYY-MM-DD HH:mm", "YYYY/MM/DD HH:mm"],
      },
      hour: "00",
      minute: "00",
      second: "00",
    };
  },
  computed: {
    timezone() {
      return localStorage.getItem("timezone");
    },
    optionHours() {
      let hours = [];
      for (let index = 0; index < 24; index++) {
        let hour = this.addZero(index);
        hours.push(hour);
      }
      return hours;
    },
    optionMinutesSeconds() {
      let hours = [];
      for (let index = 0; index < 60; index++) {
        let minSec = this.addZero(index);
        hours.push(minSec);
      }
      return hours;
    },
  },
  watch: {
    minuteEvent() {
      this.toUtc();
      this.setTime();
    },
  },
  created() {
    if (this.timezone) {
      this.$moment.tz.setDefault(this.timezone);
    }
    this.toUtc();
    this.setTime();
  },
  methods: {
    change(e) {
      this.$emit("change", e);
    },
    updateTime(value, type) {
      this[type] = value;

      this.date = this.$moment(this.date)
        .set(type, parseInt(value, 10))
        .format("YYYY-MM-DDTHH:mm:ssZ");

      this.$emit("change", this.date);
    },
    setTime() {
      let hour = this.$moment(this.date).get("hour").toString();
      this.hour = this.addZero(hour);
      let minute = this.$moment(this.date).get("minute").toString();
      this.minute = this.addZero(minute);
      let second = this.$moment(this.date).get("second").toString();
      this.second = this.addZero(second);
    },
    addZero(num) {
      num = num.toString();
      if (num.length < 2) {
        num = "0" + num;
      }
      return num;
    },
    toUtc() {
      /*
       * This function will make sure that old meeting data that has no timezone will have UTC
       */
      if (this.minuteEvent.date) {
        let utcFormatted = this.$moment
          .parseZone(this.minuteEvent.date)
          .utcOffset(0, true)
          .format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        this.date = utcFormatted;
      }
    },
  },
};
</script>
